import React from "react";
import { Navigate, Route } from "react-router-dom";
import MerchantRegisterPage from "../../../features/auth/merchant-register/pages/MerchantRegisterPage";
import Step1BasicInfo from "../../../features/auth/merchant-register/components/Step1BasicInfo/Step1BasicInfo";
import Step2VerifyEmailForm from "../../../features/auth/merchant-register/components/Step2VerifyEmail/Step2VerifyEmailForm";
import Step3EmailVerifiedSuccess from "../../../features/auth/merchant-register/components/Step3EmailVerifiedSuccess/Step3EmailVerifiedSuccess";
import Step4BusinessDetailsForm from "../../../features/auth/merchant-register/components/Step4BusinessDetails/Step4BusinessDetailsForm";
import { MerchantRegistrationRouteGuard } from "../../../features/auth/merchant-register/components/MerchantRegistrationRouteGuard";
import AppDownloadPage from "../../../features/app-download/AppDownloadPage";
import EventDeepLinkPage from "../../../features/event/EventDeepLinkPage";
import EventPublicDetailsPage from "../../../features/event/EventPublicDetailsPage";
import BillingSuccessPage from "../../../features/MERCHANT/merchant-plan/BillingSuccessPage";
import NewsDeepLinkPage from "../../../features/news/page/NewsDeepLinkPage";

const merchantRegistrationRoute = (currentStep: number, page: React.ReactElement) => (
  <MerchantRegistrationRouteGuard>
    <MerchantRegisterPage
      currentStep={currentStep}
      page={page}
    />
  </MerchantRegistrationRouteGuard>
);

export const publicRoutes = (
  <>
    <Route
      path="/qr/registration-event"
      element={<EventPublicDetailsPage />}
    />
    <Route
      path="/download"
      element={<AppDownloadPage />}
    />
    <Route
      path="/billing/success"
      element={<BillingSuccessPage />}
    />
    <Route
      path="/event/:id"
      element={<EventDeepLinkPage />}
    />
    <Route
      path="/news/:id"
      element={<NewsDeepLinkPage />}
    />
    <Route
      path="/merchant/register"
      element={
        <Navigate
          to="account"
          replace
        />
      }
    />
    <Route
      path="/merchant/register/account"
      element={merchantRegistrationRoute(0, <Step1BasicInfo />)}
    />
    <Route
      path="/merchant/register/verify-email"
      element={merchantRegistrationRoute(1, <Step2VerifyEmailForm />)}
    />
    <Route
      path="/merchant/register/email-verified"
      element={merchantRegistrationRoute(2, <Step3EmailVerifiedSuccess />)}
    />
    <Route
      path="/merchant/register/business-details"
      element={merchantRegistrationRoute(3, <Step4BusinessDetailsForm />)}
    />
    <Route
      path="/merchant/register/*"
      element={
        <Navigate
          to="/merchant/register/account"
          replace
        />
      }
    />
  </>
);
